import React from 'react';
import { CardActionable, IconCancelCircle } from '@americanexpress/dls-react';
import useDocumentTitle from '../helper/documentTitle';

const PageNotFound = () => {
  useDocumentTitle('Page Not Found | American Express');
  return (
    <CardActionable
      className="col-lg-4 col-xs-12 margin-responsive-b"
    >
      <div className="flex">
        <div className="pad-responsive-r">
          <IconCancelCircle
            className="dls-bright-blue"
            size="lg"
          />
        </div>
        <div>
          <h4 className="heading-3 margin-1-b display-block dls-bright-blue">
            Page Not Found
          </h4>
          <p className="body-1 dls-gray-06">
            The page you are looking for might have been moved or renamed.
          </p>
        </div>
      </div>
    </CardActionable>
  );
};

export default PageNotFound;
